module.exports = __webpack_public_path__ + "media/images/icons/map/purplepinkpin80x64-bd1dccd9de49b1cbf5e4110af57582f3.png";